import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Label } from "components/input/Label";
import MapaPercurso from "components/maps/MapaPercurso";
import Endereco from "model/transportes/endereco/Endereco";
import ItemRota from "model/transportes/rota/ItemRota";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { ScrollPanel } from "primereact/scrollpanel";
import { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import { converterData, formatarCep, formatarCnpj, formatarTelefone } from "utils/convert";

type Props = {
    visible: boolean;
    onHide: () => void;
    itens: ItemRota[];
    itemIndex?: number;
}

export default function ModalItensRotaVisualizar({ visible, onHide, itens, itemIndex }: Props) {

    const [currentItem, setCurrentItem] = useState(itemIndex || 0);
    const [canhotoOpen, setCanhotoOpen] = useState<boolean>(false);
    const [assinaturaOpen, setAssinaturaOpen] = useState<boolean>(false);

    const onMoveMap = (latitude: number, longitude: number) => {
        console.log("Move map to: ", latitude, longitude);
    }

    const styleTheme = {
        primaryColor: "#240E92",
        successColor: "#22c75f",
        dangerColor: "#CB1301",
        color: "#000000"
    };

    const footer = <div style={{ display: "flex", justifyContent: "space-between", padding: 1, flexDirection: "row" }} >
        <Button disabled={currentItem == 0} type="button" iconPos="left" label="Anterior" icon={"pi pi-arrow-left"}
            style={{ backgroundColor: "transparent", color: styleTheme.primaryColor, fontWeight: "bolder", borderWidth: 0, width: "130px" }}
            onClick={() => {
                setCurrentItem(currentItem - 1);
                if (itens[currentItem - 1].endereco) {
                    onMoveMap(itens[currentItem - 1].endereco?.latitude || 0, itens[currentItem - 1].endereco?.longitude || 0);
                }
            }} ></Button>
        {currentItem !== itens.length - 1 ? <Button iconPos="right" label="Próximo" icon={"pi pi-arrow-right"}
            style={{ backgroundColor: "transparent", width: "130px", color: styleTheme.primaryColor, fontWeight: "bolder", borderWidth: 0 }}
            onClick={() => {
                setCurrentItem(currentItem + 1)
                if (itens[currentItem + 1].endereco) {
                    onMoveMap(itens[currentItem + 1].endereco?.latitude || 0, itens[currentItem + 1].endereco?.longitude || 0);
                }
            }} ></Button> : null}
    </div>

    return <Dialog visible={visible} onHide={onHide} style={{ height: "80vh", width: "1000px" }} footer={footer}>
        {canhotoOpen && (
            <Lightbox
                imageTitle={"Canhoto"}
                mainSrc={`data:image/jpeg;base64,${itens[currentItem].canhoto}`}
                onCloseRequest={() => setCanhotoOpen(false)}
                reactModalStyle={{ overlay: { zIndex: 9999 } }}
            />
        )}
        {assinaturaOpen && (
            <Lightbox
                imageTitle={"Assinatura"}
                mainSrc={`data:image/png;base64,${itens[currentItem].assinaturaRecebedor}`}
                onCloseRequest={() => setAssinaturaOpen(false)}
                reactModalStyle={{ overlay: { zIndex: 9999 } }}
            />
        )}
        <ScrollPanel style={{ display: "flex", flex: 1 }} >
            <div key={currentItem} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 10 }} >
                <div style={{ display: "flex", flexDirection: "row" }} >
                    <div style={{ marginRight: "20px" }} >
                        <span style={{ fontWeight: 700 }} >{currentItem + 1}</span>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: 700 }} >{itens[currentItem].endereco?.logradouro}</span>
                        <span color={"#777"}>{itens[currentItem].endereco?.cep}</span>
                        <span style={{
                            borderColor: itens[currentItem].tipo == "COLETA" ? "#6B8E23" : styleTheme.primaryColor,
                            color: itens[currentItem].tipo == "COLETA" ? "#6B8E23" : styleTheme.primaryColor,
                            borderStyle: "solid",
                            borderWidth: 1, borderRadius: 5,
                            padding: 1, maxWidth: 100, textAlign: "center"
                        }}>{itens[currentItem].tipo == "COLETA" ? "Coleta" : "Entrega"}</span>
                    </div>
                </div>
                <div >
                    <span style={{ color: "#777" }}>{converterData(itens[currentItem].dataPrevista)}</span>
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", flex: 1, alignItems: "center", marginTop: 2 }}>
                <div style={{ display: "flex", flexDirection: "row", width: "250px", borderRadius: 10, borderColor: "#AAA", borderStyle: "solid", borderWidth: 1, backgroundColor: "#eaeaea" }} >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            borderTopLeftRadius: 10,
                            borderBottomLeftRadius: 10,
                            borderRightStyle: "solid",
                            borderRightColor: "#AAA",
                            borderRightWidth: 1,
                            flex: 1,
                            alignItems: "center",
                            ...itens[currentItem].resultado == "N" ? { backgroundColor: styleTheme.dangerColor } : {}
                        }}
                    >
                        <FontAwesomeIcon icon="close" size="6x" color={itens[currentItem].resultado == "N" ? "#FFF" : styleTheme.dangerColor} />
                        <span
                            style={itens[currentItem].resultado == "N" ?
                                { color: "#FFF", fontWeight: 700 }
                                : { color: "#000" }}
                        >
                            {itens[currentItem].tipo == "COLETA" ? "Não coletado" : "Não entregue"}
                        </span>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            borderTopRightRadius: 10,
                            borderBottomRightRadius: 10,
                            flex: 1,
                            alignItems: "center",
                            ...itens[currentItem].resultado == "S" ? { backgroundColor: styleTheme.successColor } : {}
                        }}
                    >
                        <FontAwesomeIcon icon="check" color={itens[currentItem].resultado == "S" ? "#FFF" : styleTheme.successColor} size="6x" />
                        <span
                            style={itens[currentItem].resultado == "S" ? { color: "#FFF", fontWeight: 700 } : { color: "#000" }}
                        >
                            {itens[currentItem].tipo == "COLETA" ? "Coletado" : "Entregue"}
                        </span>
                    </div>
                </div>
            </div>

            <div style={{ paddingLeft: 1, paddingRight: 1, marginRight: 2 }} >
                <InputTextarea placeholder={"Observação do motorista"} color={styleTheme.color} style={{ width: "100%", marginTop: 8 }} value={itens[currentItem].observacaoMotorista} />
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", flexDirection: "row", marginTop: 3, flexWrap: "wrap" }}>
                {itens[currentItem].imagens.map((imagem, index) => {
                    return (
                        <img key={index} src={`data:image/jpeg;base64,${imagem.base64}`} style={{ width: 100, height: 100, margin: 5, borderRadius: 10 }} />
                    )
                })}
            </div>
            <MapaPercurso pontosPercurso={itens[currentItem].pontosPercurso} destino={itens[currentItem].endereco as Endereco} />

            <div style={{ marginTop: 15 }} >
                <Label style={{ fontSize: 18, fontWeight: "bold", marginBottom: 10 }}>Informações do CT-e</Label>
                <div style={{ display: "flex", flexDirection: "row", columnGap: 20, flexWrap: "wrap" }} >
                    <span><b>Número: </b>{itens[currentItem].mdfeCte?.cte?.nct}</span>
                    <span><b>Série: </b>{itens[currentItem].mdfeCte?.cte?.serie}</span>
                    {itens[currentItem].mdfeCte?.cte?.infCarga?.listInfQ?.map((infQ, index) => {
                        if (infQ.cunid === "01") {
                            return <span><b>Peso Bruto: </b>{infQ.qcarga}</span>
                        }
                        if (infQ.cunid === "03") {
                            return <span><b>Volumes: </b>{infQ.qcarga}</span>
                        }
                        return null;
                    })}
                </div>
                <span><b>Observações: </b>{itens[currentItem].mdfeCte?.cte?.dadosComplementares?.xobs}</span>
            </div>

            <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid #d9d9d9" }} >
                <Label>Dados do remetente</Label>
                <div style={{ display: "flex", flexDirection: "row", columnGap: 20, flexWrap: "wrap" }} >
                    <span><b>Nome: </b>{itens[currentItem].mdfeCte?.cte?.remetente?.xNome}</span>
                    <span><b>CNPJ: </b>{formatarCnpj(itens[currentItem].mdfeCte?.cte?.remetente?.cnpj || "")}</span>
                    <span><b>Cidade: </b>{itens[currentItem].mdfeCte?.cte?.remetente?.enderRem.xMun} - {itens[currentItem].mdfeCte?.cte?.remetente?.enderRem.uf}</span>
                </div>
            </div>

            <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid #d9d9d9" }} >
                <Label>Dados do destinatário</Label>
                <div style={{ display: "flex", flexDirection: "row", columnGap: 20, flexWrap: "wrap" }} >
                    <span><b>Nome: </b>{itens[currentItem].mdfeCte?.cte?.destinatario?.xNome}</span>
                    <span><b>CNPJ: </b>{formatarCnpj(itens[currentItem].mdfeCte?.cte?.destinatario?.cnpj || "")}</span>
                    <span><b>Cidade: </b>{itens[currentItem].mdfeCte?.cte?.destinatario?.enderDest.xMun} - {itens[currentItem].mdfeCte?.cte?.destinatario?.enderDest.uf}</span>
                    <span><b>CEP: </b>{formatarCep(itens[currentItem].mdfeCte?.cte?.destinatario?.enderDest.cep || "")} </span>
                    <span><b>Endereço: </b>{itens[currentItem].mdfeCte?.cte?.destinatario?.enderDest.xLgr}, {itens[currentItem].mdfeCte?.cte?.destinatario?.enderDest.nro} - {itens[currentItem].mdfeCte?.cte?.destinatario?.enderDest.xBairro}</span>
                    <span><b>Fone: </b>{formatarTelefone(itens[currentItem].mdfeCte?.cte?.destinatario?.fone || "")}</span>

                </div>
            </div>

            <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid #d9d9d9" }} >
                <Label>Documentos Originários</Label>
                <div style={{ display: "flex", flexDirection: "row", columnGap: 20, flexWrap: "wrap" }} >
                    {itens[currentItem].mdfeCte?.cte?.listInfNfe.map((nfe, index) => {
                        return <span><b>Nota Fiscal: </b>{nfe.chave.substring(25, 34)}</span>
                    })}
                </div>
            </div>

            <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid #d9d9d9", display: "flex", flexDirection: "row", justifyContent: "space-between" }} >
                <div style={{ display: "flex", flexDirection: "column" }} >
                    <span style={{ fontWeight: 700 }} >Dados do recebedor</span>
                    <span><b>Nome: </b>{itens[currentItem].nomeRecebedor}</span>
                    <span><b>Documento: </b>{itens[currentItem].documentoRecebedor}</span>
                    <span><b>Telefone: </b>{itens[currentItem].telefoneRecebedor}</span>
                </div>
                {itens[currentItem].assinaturaRecebedor && <div style={{ display: "flex", flexDirection: "column" }} >
                    <span style={{ fontWeight: 700 }} >Assinatura</span>
                    <img src={`data:image/png;base64,${itens[currentItem].assinaturaRecebedor}`} onClick={() => {
                        setTimeout(() => {
                            setAssinaturaOpen(true);
                        }, 100)
                    }} style={{ height: 100, borderRadius: 10 }} />
                </div>}
                {itens[currentItem].canhoto && <div style={{ display: "flex", flexDirection: "column" }} >
                    <span style={{ fontWeight: 700 }} >Canhoto</span>
                    <img src={`data:image/jpeg;base64,${itens[currentItem].canhoto}`} onClick={() => {
                        setTimeout(() => {
                            setCanhotoOpen(true);
                        }, 100)
                    }} style={{ height: 100, borderRadius: 10 }} />
                </div>}
            </div>

        </ScrollPanel>
    </Dialog>

}